<script lang="ts">
  import Badge from 'Catalyst/components/Badge/Badge.svelte';
  import CatalystApp from 'Catalyst/components/CatalystApp/CatalystApp.svelte';
  import {deal, socialProofingDataStore} from 'Store/InvestorFlowStore';

  // Props for customizing badge copy (optional with defaults)
  export let engagedInvestorsText: string = '{0} eyeing this investment';
  export let recentInvestorsText: string = '{0} investors in {1} days';
  export let totalInvestorsText: string = '{0} total investors';

  const engagedInvestorsFlag =
    $deal.feature_flags.investor_conversion_engaged_investors;
  const showEngagedInvestorsBadge = engagedInvestorsFlag
    ? $socialProofingDataStore.engagedInvestors >=
      $socialProofingDataStore.engagedInvestorsThreshold
    : false;
  const recentInvestorsFlag =
    $deal.feature_flags.investor_conversion_recent_investors;
  const showRecentInvestorsBadge = recentInvestorsFlag
    ? $socialProofingDataStore.recentInvestors >=
      $socialProofingDataStore.recentInvestorsThreshold
    : false;
  const totalInvestorsFlag =
    $deal.feature_flags.investor_conversion_total_investors;
  const showTotalInvestorsBadge = totalInvestorsFlag
    ? $socialProofingDataStore.totalInvestors >=
      $socialProofingDataStore.totalInvestorsThreshold
    : false;

  // Helper function to substitute placeholders
  const substitutePlaceholders = (
    text: string,
    ...values: (string | number)[]
  ): string => {
    return text.replace(/{(\d+)}/g, (match, index) => {
      const idx = parseInt(index, 10);
      return idx < values.length ? String(values[idx]) : match;
    });
  };
</script>

<CatalystApp>
  <div
    class="social-proofing-badge-container"
    data-testid="social-proofing-badge-container"
  >
    {#if showEngagedInvestorsBadge}
      <Badge
        label={substitutePlaceholders(
          engagedInvestorsText,
          $socialProofingDataStore.engagedInvestors
        )}
        leadingEmojiGlyph="&#128064;"
        semantic="brand"
      />
    {/if}
    {#if showRecentInvestorsBadge}
      <Badge
        label={substitutePlaceholders(
          recentInvestorsText,
          $socialProofingDataStore.recentInvestors,
          $socialProofingDataStore.recentInvestorDateRangeDays
        )}
        leadingEmojiGlyph="&#x1F525;"
        semantic="brand"
      />
    {/if}
    {#if showTotalInvestorsBadge}
      <Badge
        label={substitutePlaceholders(
          totalInvestorsText,
          $socialProofingDataStore.totalInvestors
        )}
        leadingEmojiGlyph="&#9889;"
        semantic="brand"
      />
    {/if}
  </div>
</CatalystApp>

<style>
  .social-proofing-badge-container {
    margin-top: 1.2rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    align-items: flex-start;
  }
</style>
